import React from "react";

const App = () => {
  return (
    <div className="relative w-full min-h-screen overflow-y-auto font-sans text-white">
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
      >
        <source src="/bg.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-60 z-0"></div>

      {/* Main Content */}
      <div className="relative z-10 px-6 py-12 space-y-24">

        {/* Hero */}
        <section className="min-h-screen flex flex-col items-center justify-center text-center space-y-6">
          <h1 className="text-4xl md:text-6xl font-bold text-jonquil drop-shadow-lg">
            Exotic Co.
          </h1>
          <p className="text-xl md:text-2xl text-rebeccaPurple max-w-3xl">
            A robust and creative tech house building Web3 platforms, mobile apps, and immersive digital experiences.
          </p>
        </section>

        {/* About */}
        <section id="about" className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-jonquil mb-4">About Us</h2>
          <p className="text-lg text-white">
            We are a team of engineers, designers, and strategists passionate about the decentralized future.
            Our mission is to craft beautiful and functional products in the Web3 space, from dApps to full-blown platforms.
          </p>
        </section>

        {/* Services */}
        <section id="services" className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-jonquil mb-8">Our Services</h2>
          <div className="grid md:grid-cols-3 gap-6 px-4">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-purpureus bg-opacity-30 backdrop-blur-md p-6 rounded-2xl shadow-xl border border-purple-500"
              >
                <h3 className="text-xl font-semibold text-jonquil">{service}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* Work / Projects */}
        <section id="work" className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-jonquil mb-10 text-center">Our Work</h2>
          <div className="grid md:grid-cols-3 gap-6 px-4">
            {projects.map((project, index) => (
              <div
                key={index}
                className="bg-purpureus bg-opacity-30 backdrop-blur-md p-6 rounded-2xl shadow-xl hover:scale-105 transform transition-all duration-300 border border-purple-500"
              >
                <h3 className="text-2xl font-semibold text-jonquil">{project.name}</h3>
                <p className="text-sm mt-2 text-white">{project.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-jonquil mb-10">Testimonials</h2>
          <div className="flex gap-6 overflow-x-auto scrollbar-hide px-4">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="min-w-[300px] bg-purpureus bg-opacity-20 p-6 rounded-xl shadow-md border border-purple-400"
              >
                <p className="italic text-white">"{t.quote}"</p>
                <h4 className="mt-4 font-semibold text-jonquil">- {t.author}</h4>
              </div>
            ))}
          </div>
        </section>

        {/* Contact / Footer */}
        <section id="contact" className="text-center mt-20">
          <h2 className="text-3xl font-bold text-jonquil mb-4">Get in Touch</h2>
          <p className="text-white mb-6">
            Have a project or idea? Reach out and let's build something amazing together.
          </p>
          <a
            href="mailto:hello@exoticco.xyz"
            className="inline-block bg-carminePink text-white px-6 py-3 rounded-full font-semibold hover:bg-opacity-80 transition"
          >
            Contact Us
          </a>
          <p className="text-sm text-white mt-8">© 2025 Exotic Co. All rights reserved.</p>
        </section>
      </div>
    </div>
  );
};

const services = [
  "Telegram Airdrop Bots",
  "Landing Pages & Websites",
  "Web3 DApp Integration",
  "Mobile App Development",
  "Token Utility Projects",
  "Dashboard/Admin Panel UI",
];

const projects = [
  {
    name: "DEX Aggregator UI",
    description: "Built a responsive frontend for a DeFi aggregator, integrated wallet connect, and chart analytics.",
  },
  {
    name: "NFT Marketplace",
    description: "Developed smart contract interaction with a clean, animated interface and metadata sync.",
  },
  {
    name: "Crypto Portfolio Tracker",
    description: "Mobile app that visualizes wallets, token balances, and live price updates from APIs.",
  },
  {
    name: "Airdrop Telegram Bot",
    description: "Created Python-based Telegram bot for giveaways, wallet submissions, and referral rewards.",
  },
  {
    name: "Web3 Launchpad",
    description: "Complete site for token launches with KYC, vesting dashboards, and investor portals.",
  },
  {
    name: "Community DAO Portal",
    description: "On-chain voting and proposal management site with token-gated access features.",
  },
];

const testimonials = [
  {
    quote: "Exotic Co. transformed our idea into a polished product. Exceptional quality!",
    author: "CryptoHub Founder",
  },
  {
    quote: "They nailed our Web3 integration. Reliable, fast, and super creative.",
    author: "DAO Tools Team",
  },
  {
    quote: "Our Telegram bot went viral thanks to Exotic Co.’s clean and functional build.",
    author: "Marketing DAO Lead",
  },
];

export default App;
